<template>
  <div class="dialog-select" :class="customClass">
    <p class="dialog-select-label my-0">{{ label }}</p>
    <v-select
      :placeholder="placeholder"
      :items="items"
      :value="value"
      :disabled="disabled"
      height="48"
      solo
      flat
      dense
      full-width
      hide-details
      :item-text="itemText"
      :item-value="itemValue"
      :clearable="clearable"
      @input="$emit('input', { name, value: $event })"
    />
  </div>
</template>

<script>
export default {
  name: 'DialogSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'text',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    customClass: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.dialog-select {
  ::v-deep .v-icon.mdi.mdi-menu-down {
    background-color: $bh-blue--4;
    color: $bh-blue;
    padding: 0.25 * $gutter;
  }
  &-label {
    color: $bh-gray--2;
  }
  &.filter {
    .v-input__slot {
      border-radius: 9999px;
      background: $bh-gray--6 !important;
      .v-icon {
        color: $bh-blue !important;
      }
    }
  }
}
</style>
